module.exports = __webpack_public_path__ + "img/1.6bb9735a.webp";